export enum WorkoutExerciseType {
  WARMUP = 'WARMUP',
  MAIN = 'MAIN',
  COOLDOWN = 'COOLDOWN',
}
